module.exports = __webpack_public_path__ + "img/home-welcome.a47effca.png";